import React, { useState } from "react";
import "./style.scss";
import { TextField } from "@mui/material";
import CheckboxCustom from "../../../features/CheckboxCustom";
import useNewsletterConfirmation from "../NewsletterConfirmation/useNewsletterConfirmation";
import useFacility from "../../../utils/hooks/useFacility";
import EAButton from "../shared/Buttons/EAButton";
import EAAlert from "../shared/EAAlert";

const NewsletterFormWidget: React.FC = () => {
  const [form, setForm] = useState({ mail: "", name: "", lastName: "", checkbox1: false, checkbox2: false });
  const { sendInvite, alert, error } = useNewsletterConfirmation();
  const facilityIds = useFacility();
  const isEmailValid = (value: string): boolean => {
    // Basic email validation using a regular expression
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(value);
  };

  const isSubmitDisabled = () => {
    if (isEmailValid(form.mail) && form.checkbox1 === true) {
      return false;
    } else {
      return true;
    }
  };
  return (
    <div className="newsletter-form-container">
      <h1 className="newsletter-form-title">Zapisz się do naszego newslettera – załóż konto i bądź na bieżąco!</h1>
      <span className="newsletter-form-body">
        Założenie konta umożliwia otrzymywanie newslettera Kortosfery oraz zakup biletów.
      </span>

      {/* <div className="newsletter-form-inputs-name-wrapper">

        <div className="newsletter-name-input">
          <TextField
            type="imię"
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            variant="outlined"
            label="Wpisz imię"
            fullWidth
          />
        </div>  <div className="newsletter-name-input">
          <TextField
            type="Nazwisko"
            value={form.lastName}
            onChange={(e) => setForm({ ...form, lastName: e.target.value })}
            variant="outlined"
            label="Wpisz nazwisko"
            fullWidth
          />
        </div>
      </div> */}

      <div className="newsletter-form-inputs-wrapper">
        <div className="newsletter-mail-input">
          <TextField
            type="email"
            value={form.mail}
            onChange={(e) => setForm({ ...form, mail: e.target.value })}
            variant="outlined"
            label="Wpisz adres email"
            fullWidth
          />
        </div>
        <EAButton title="Dołącz" onClick={() => sendInvite(facilityIds, form.mail)} disabled={isSubmitDisabled()} />
      </div>

      {error && <EAAlert type="error" message={error} />}
      {alert.length > 2 && <EAAlert type="success" message={alert} />}

      <div className="newsletter-form-checkboxes-wrapper">
        <CheckboxCustom
          value={form.checkbox1}
          setValue={(value) => setForm({ ...form, checkbox1: value })}
          label="Zaznaczając to pole, wyrażam zgodę na założenie konta oraz subskrypcję newslettera. Zobowiązuję się do przestrzegania
           <a target='_blank' href='https://panel.eaktywni.pl/img/1228/Załącznik_nr_1_-_sprzedaż_biletów.pdf'>Regulaminu</a> oraz
            <a target='_blank' href='https://panel.eaktywni.pl/img/1228/klauzula_informacyjna_new.pdf'>Polityki Prywatności</a> serwisu."
        />

        {/* <CheckboxCustom
    value={form.checkbox2}
    setValue={(value) => setForm({ ...form, checkbox2: value })}
    label="Zgoda na kontakt telefoniczny"
  /> */}
      </div>
      <article>
        Informujemy, że Państwa zgoda może zostać cofnięta w dowolnym momencie przez dostarczenie formularza cofnięcia
        zgody do Centrum Popularyzacji Nauki i Innowacji - Kortosfera lub Inspektorowi Ochrony Danych UWM. Cofnięcie
        zgody nie będzie wpływać na zgodność z prawem przetwarzania, którego dokonano na podstawie Państwa zgody przed
        jej wycofaniem.
      </article>
    </div>
  );
};

export default NewsletterFormWidget;
